import { useTranslation } from 'react-i18next';
import PageHero from '../../components/shared/PageHero';
import Sidebar from '../../components/shared/Sidebar';
import AdmissionsSegments from './components/AdmissionsSegments';
import AdmissionsSteps from './components/AdmissionsSteps';

export default function Admissions() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col bg-white">
      {/* Page Hero with Background Image */}
      <PageHero 
        title={t('admissions_title', 'Admissions')}
        quote={t('about_mission_text', "Enseigner, apprendre, en tout temps, en tout lieu et quelque soit l'âge.")}
        breadcrumbs={[{ label: t('nav_admissions', 'Admissions'), href: '/admissions' }]}
        variant="image"
        image="/images/campus/students-01.jpg"
      />

      <main className="py-20 px-6 lg:px-12 bg-gray-50">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-16">
          
          {/* Main Content Area */}
          <div className="flex-1 space-y-24">
            {/* Segment Cards */}
            <AdmissionsSegments />

            {/* Steps Timeline */}
            <AdmissionsSteps />
          </div>

          {/* Right Sidebar */}
          <Sidebar variant="admissions" />
        </div>
      </main>
    </div>
  );
}
